import _export from '../internals/export.js';
import isIntegralNumber$1 from '../internals/is-integral-number.js';

var $ = _export;
var isIntegralNumber = isIntegralNumber$1; // `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger

$({
  target: 'Number',
  stat: true
}, {
  isInteger: isIntegralNumber
});
